export const TRANSCEND_CONSENT_LS_KEY = 'tcmConsent'
export const TRANSCEND_ALLOW_ALL_CONSENT = 'transcend_allow_all_consent'
